export type Role =
	| "admin"
	| "manager"
	| "driver"
	| "telemetryadmin"
	| "telemetrymember";

export type PermissionModules =
	| "users"
	| "vehicles"
	| "forms"
	| "histories"
	| "copiloto";

export const Permissions: Record<Role, Record<PermissionModules, string[]>> = {
	admin: {
		users: ["view", "create", "edit", "delete"],
		vehicles: ["view", "create", "edit", "delete"],
		forms: ["view", "create", "edit", "delete"],
		histories: ["view", "create", "edit", "delete"],
		copiloto: ["use"],
	},

	manager: {
		users: ["view", "create", "edit", "delete"],
		vehicles: ["view", "create", "edit", "delete"],
		forms: ["view", "create", "edit", "delete"],
		histories: ["view"],
		copiloto: ["use"],
	},

	driver: {
		users: [],
		vehicles: [],
		forms: [],
		histories: ["view_own"],
		copiloto: [],
	},

	telemetryadmin: {
		users: ["view", "create", "edit", "delete"],
		vehicles: ["view"],
		forms: [],
		histories: [],
		copiloto: [],
	},

	telemetrymember: {
		users: [],
		vehicles: ["view"],
		forms: [],
		histories: [],
		copiloto: [],
	},
};

export const TELEMETRY_TRACKING_PATH_PREFIX = "/tracking";

/** Blocks BackOffice when the user has driver role, even combined with other roles. */
export function shouldBlockBackofficeAccess(roles: Role[]): boolean {
	return roles.includes("driver");
}

function isPathUnderPrefix(pathname: string, prefix: string): boolean {
	return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

function canViewUsers(roles: Role[]): boolean {
	return roles.some(
		(role) => Permissions[role]?.users?.includes("view") ?? false
	);
}

export function hasTelemetryRestrictedNav(roles: Role[]): boolean {
	if (!roles.length) {
		return false;
	}

	if (roles.some((role) => role === "admin" || role === "manager")) {
		return false;
	}

	return roles.some(
		(role) => role === "telemetryadmin" || role === "telemetrymember"
	);
}

export function isTelemetryAllowedPath(
	pathname: string,
	roles: Role[]
): boolean {
	if (isPathUnderPrefix(pathname, TELEMETRY_TRACKING_PATH_PREFIX)) {
		return true;
	}

	if (isPathUnderPrefix(pathname, "/users")) {
		return canViewUsers(roles);
	}

	return false;
}

export function getDefaultAuthenticatedPath(roles: Role[]): string {
	if (hasTelemetryRestrictedNav(roles)) {
		return "/tracking";
	}

	return "/home";
}
